var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M115.4,20.5c-8.7,0-16.9,3.4-23.1,9.6L64.2,58.2c0,0,0-17.3,0-17.4c-0.1-4.9-4.1-8.7-9-8.7c-2.5,0-4.7,1-6.4,2.6L26.1,57.5 l12.7,12.7l15.1-15.1v9.2c0,1.2,0.4,2.3,1.1,3.2L41.9,80.5L22.5,61.1c-4,4-4,10.5,0,14.5l12.2,12.2l-1.2,1.2 c-5.7,5.7-13.2,8.8-21.2,8.8H0v2.7h12.3c8.7,0,16.9-3.4,23.1-9.6l1.2-1.2l4.8,4.8l-20.7,20.7c-2,2-2,5.3,0,7.3s5.3,2,7.3,0 c0,0,24.3-24.3,24.3-24.3c2-2,2-5.2,0-7.2l-8.5-8.5l13.3-13.4c0.6,0.2,1.2,0.3,1.8,0.3h23.2c2.8,0,5.1-2.3,5.1-5.1 c0-2.8-2.3-5.1-5.1-5.1H67.1L94.3,32c5.7-5.7,13.2-8.8,21.2-8.8h13v37.3c0,2.1-1.7,3.8-3.8,3.8c-1,0-2-0.4-2.7-1.1l-14.1-14.1 L106,51l14.1,14.1c1.2,1.2,2.9,1.9,4.6,1.9c3.6,0,6.5-2.9,6.5-6.5V20.5H115.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.7,
    cy: 24.4,
    r: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorse);
export default __webpack_public_path__ + "static/media/horse.312ad4c8e414839554395858a2f69ff0.svg";
export { ForwardRef as ReactComponent };